import React from 'react';
import { LineComponent } from './components/line';
import { useStepperLogic } from './hooks/useStepper';
import styles from './styles.module.scss';

type Props = {
  className: string;
  stepName: string;
  currentStep: number;
  stepsTotal: number;
  currentSubstep: number;
  substepsTotal: number;
};

export const LivenStepper: React.FC<Props> = ({
  className,
  stepName,
  currentStep,
  stepsTotal,
  currentSubstep,
  substepsTotal,
}: Props) => {
  const { steps } = useStepperLogic({
    stepName,
    currentStep,
    stepsTotal,
    currentSubstep,
    substepsTotal,
  });

  return (
    <div
      className={`
        ${styles.container} 
        ${className} 
      `}
    >
      {steps.map((step, index) => (
        <LineComponent
          key={`line-${index}`}
          item={step}
          className={className}
        />
      ))}
    </div>
  );
};
